import type { UIStringsOverride } from "../i18n-ui.ts";

/** Chinese — Simplified (zh) UI strings. */
export const zh: UIStringsOverride = {
  actions: {
    addToCursor: "添加到 Cursor",
    addToVscode: "添加到 VS Code",
    askAI: "向 AI 询问此页面",
    connectMcp: "连接到 MCP",
    copied: "已复制！",
    copyClaudeCode: "复制 Claude Code 命令",
    copyCode: "复制代码",
    copyCodex: "复制 Codex 命令",
    copyMarkdown: "复制为 Markdown",
    copyServerUrl: "复制服务器 URL",
    edit: "在 GitHub 上编辑",
    export: "导出",
    exportEpub: "导出为 EPUB",
    exportPdf: "导出为 PDF",
    generating: "生成中…",
    openIn: "在 {name} 中打开",
    openInChat: "在聊天中打开",
    scrollToTop: "回到顶部",
  },
  ask: {
    ai: "AI",
    clear: "清空对话",
    close: "关闭",
    copy: "复制对话",
    empty: "就文档提出问题。",
    error: "抱歉，出了点问题。",
    label: "提出问题",
    placeholder: "提出问题…",
    send: "发送",
    tip: "提示：可通过以下快捷键打开和关闭聊天",
    title: "向 AI 提问",
    you: "你",
  },
  banner: { dismiss: "关闭公告" },
  changelog: {
    description: "产品更新与版本说明。",
    showReleases: "显示 {version} 的发布",
    title: "更新日志",
  },
  content: {
    diagramError: "无法渲染此图表。",
  },
  feedback: {
    no: "没有帮助",
    question: "这个页面有帮助吗？",
    thanks: "感谢你的反馈！",
    yes: "有帮助",
  },
  languageSwitcher: { label: "语言", untranslated: "未翻译" },
  nav: {
    back: "返回",
    breadcrumb: "面包屑导航",
    closeNavigation: "关闭导航",
    deprecated: "已弃用",
    featured: "精选",
    githubRepository: "GitHub 仓库",
    navigation: "导航",
    primary: "主要",
    sections: "章节",
    toggleNavigation: "切换导航",
    toggleTheme: "切换颜色主题",
  },
  notFound: {
    description: "我们找不到你要访问的页面。",
    home: "返回首页",
    title: "页面未找到",
  },
  page: {
    lastUpdated: "最后更新于",
    next: "下一页",
    pagination: "分页",
    previous: "上一页",
    skipToContent: "跳到内容",
  },
  search: {
    all: "全部",
    allLanguages: "所有语言",
    askAi: "向 AI 提问",
    askAiHint: "从 AI 即时获取答案",
    button: "搜索",
    devOnly: "搜索在生产构建中可用。",
    error: "出了点问题，请重试。",
    label: "搜索文档",
    navigate: "导航",
    noResults: "未找到结果。",
    open: "打开",
    placeholder: "搜索文档…",
    popular: "热门",
    preview: "预览",
    results: "结果",
  },
  toc: { title: "本页内容" },
};
